import { render, staticRenderFns } from "./PageContentHelp.vue?vue&type=template&id=60068358&scoped=true"
import script from "./PageContentHelp.vue?vue&type=script&lang=js"
export * from "./PageContentHelp.vue?vue&type=script&lang=js"
import style0 from "./PageContentHelp.vue?vue&type=style&index=0&id=60068358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60068358",
  null
  
)

export default component.exports